export const demoEs = {
  // ── DemoPage: Seo ──────────────────────────────────────────────────────────
  'demo.seoTitle': 'Juega ahora — Entra en Grymwyrd',
  'demo.seoDescription':
    'Haz girar el mundo, tómate asiento en la mesa, forja un héroe de Grymwyrd y lanza los dados — una guía interactiva por la mesa virtual de Grymwyrd.',

  // ── DemoPage: GlobeStep ─────────────────────────────────────────────────────
  'demo.globe.worldAriaLabel': 'El mundo de Grymwyrd',
  'demo.globe.spinningWorld': 'Girando el mundo…',
  'demo.globe.tagline': 'Un mundo de horror fantástico viviente',
  'demo.globe.arrivedHeading': 'Región de Greywick',
  'demo.globe.heading': 'Encuentra tu lugar en el crepúsculo eterno',
  'demo.globe.subheading': 'Una mesa te espera en el corazón del mundo. Tómate asiento y forja un héroe.',
  'demo.globe.enterCta': 'Desciende a Grymwyrd',

  // ── DemoPage: AccountStep ───────────────────────────────────────────────────
  'demo.account.heading': 'Conviértete en parte de la historia',
  'demo.account.subheading':
    'Crea una cuenta gratuita para desbloquear la enciclopedia completa de Grymwyrd y guardar el héroe que estás a punto de forjar — o pasa como invitado y explora ahora.',
  'demo.account.createAccount': 'Crear una cuenta',
  'demo.account.logIn': 'Iniciar sesión',
  'demo.account.continueAsGuest': 'Continuar como invitado',

  // ── DemoPage: CreateStep ────────────────────────────────────────────────────
  'demo.create.abilityRollLabel': '{ability} (3d6)',
  'demo.create.initiativeLabel': 'Iniciativa',
  'demo.create.lobbyEyebrow': 'Mesa Virtual Grymwyrd · Vestíbulo',
  'demo.create.heading': 'Forja tu héroe',
  'demo.create.subheading': 'Un personaje de SRD 5.2.1, nacido de Grymwyrd. Nómbralo, elige un arquetipo y lanza los dados.',
  'demo.create.nameLabel': 'Nombre',
  'demo.create.namePlaceholder': '¿Quién es?',
  'demo.create.chooseCalling': 'Elige tu arquetipo',
  'demo.create.keyAbility': 'Clave: {ability}',
  'demo.create.abilityScores': 'Puntuaciones de atributo',
  'demo.create.abilityScoresHint': '— pulsa para tirar 3d6',
  'demo.create.rollAbilityAria': 'Tirar {ability} (3d6)',
  'demo.create.keepStandard': 'O mantén los 10 estándar y comienza.',
  'demo.create.initiativeResult': 'Iniciativa {initiative} — lanza los dados, la mesa se gira hacia ti…',
  'demo.create.bonesTumble': 'Los dados se deslizan…',
  'demo.create.rollInitiativeCta': 'Tira para iniciativa y tómate tu asiento',
  'demo.create.chooseCallingHint': 'Elige un arquetipo para tomar tu asiento.',

  // ── DemoTableStep ───────────────────────────────────────────────────────────
  'demo.table.errorHeading': 'No se pudo preparar la mesa',
  'demo.table.errorBody': 'La mesa virtual no está disponible en este momento.',
  'demo.table.browseLiveTables': 'Explora mesas activas en su lugar',
  'demo.table.settingTable': 'Preparando tu mesa…',
  'demo.table.connecting': 'Conectando a la mesa virtual…',
  'demo.table.heroTable': 'Mesa de {name}',
  'demo.table.firstTable': 'Tu primera mesa',
  'demo.table.diceTrayHeading': 'Bandeja de dados',
  'demo.table.initiativeHeading': 'Iniciativa',
  'demo.table.initiativePrompt': 'Lanza los dados para fijar el orden de combate.',
  'demo.table.rollForInitiative': 'Tirar para iniciativa',
  'demo.table.vttEyebrow': 'Grymwyrd VTT',
  'demo.table.xcardTitle': 'Pausa el juego, anónimamente',
  'demo.table.xcard': 'Tarjeta X',
  'demo.table.saveHeroTitle': 'Crea una cuenta gratuita para guardar tu héroe',
  'demo.table.saveHero': 'Guardar héroe',
  'demo.table.statusLive': 'En vivo',
  'demo.table.statusConnecting': 'Conectando',
  'demo.table.actionLogHeading': 'Registro de acciones',
  'demo.table.recentRollsHeading': 'Tiradas recientes',

  // ── DemoTableStep: dock panel titles ────────────────────────────────────────
  'demo.panel.heroSheet': 'Hoja de Héroe',
  'demo.panel.companion': 'Dispositivo Compañero',
  'demo.panel.diceTray': 'Bandeja de Dados',
  'demo.panel.macros': 'Macros',
  'demo.panel.diceConsole': 'Consola de Dados',
  'demo.panel.initiative': 'Iniciativa',
  'demo.panel.poll': 'Votación',
  'demo.panel.recentRolls': 'Tiradas Recientes',
  'demo.panel.reference': 'Referencia',
  'demo.panel.chat': 'Chat',
  'demo.panel.handouts': 'Documentos',
  'demo.panel.safety': 'Seguridad',
  'demo.panel.sceneAndCues': 'Escena y Pistas',
  'demo.panel.replay': 'Reproducción',
  'demo.panel.recap': 'Resumen',
  'demo.panel.actionLog': 'Registro de Acciones',

  // ── DemoTableStep: ActionBar ────────────────────────────────────────────────
  'demo.action.melee': 'Cuerpo a Cuerpo',
  'demo.action.cast': 'Lanzar',
  'demo.action.move': 'Movimiento',
  'demo.action.block': 'Bloquear',
  'demo.action.chooseTarget': 'Elige un objetivo para {action}…',
  'demo.action.controlling': 'Controlando:',
  'demo.action.cannotAct': '{label} no puede actuar — selecciona una turba, jugador, vehículo o PNJ.',
  'demo.action.selectActionable': 'Selecciona un objeto interactivo para actuar con él.',
  'demo.action.cancel': 'Cancelar',

  // ── DemoTableStep: InitiativeTracker ────────────────────────────────────────
  'demo.tracker.rollingOrder': 'Calculando el orden…',
  'demo.tracker.combatant': 'Combatiente {n}',
  'demo.tracker.previousTurn': 'Turno anterior',
  'demo.tracker.round': 'Ronda {round}',
  'demo.tracker.endCombatTitle': 'Finalizar combate',
  'demo.tracker.end': 'Finalizar',
  'demo.tracker.nextTurnTitle': 'Siguiente turno',
  'demo.tracker.next': 'Siguiente',
  'demo.tracker.hitPoints': 'Puntos de golpe',
  'demo.tracker.reduceHp': 'Reducir PG de {name}',
  'demo.tracker.raiseHp': 'Aumentar PG de {name}',
  'demo.tracker.addStatusEffect': 'Añadir efecto de estado',
  'demo.tracker.removeFromOrder': 'Quitar del orden',
  'demo.tracker.removeFromOrderTitle': 'Quitar del orden',
  'demo.tracker.removeCondition': 'Quitar {name}',
  'demo.tracker.roundsShort': '{n}r',

  // ── DemoTableStep: XCardOverlay ─────────────────────────────────────────────
  'demo.xcard.ariaLabel': 'La mesa está pausada',
  'demo.xcard.heading': 'La mesa está pausada',
  'demo.xcard.body':
    'Alguien levantó la Tarjeta X. Pausamos, sin preguntas y sin acusaciones. Cuando todos estén listos, continuamos.',
  'demo.xcard.resume': 'Estamos listos — continuar',

  // ── DemoTableStep: HandoutsCard ─────────────────────────────────────────────
  'demo.handouts.heading': 'Documentos',
  'demo.handouts.titlePlaceholder': 'Título (opcional)',
  'demo.handouts.bodyPlaceholder': 'Una nota, una pista, una lectura en voz alta…',
  'demo.handouts.push': 'Enviar a la mesa',
  'demo.handouts.whispered': 'Susurrado',
  'demo.handouts.dismiss': 'Descartar documento',

  // ── DemoTableStep: SafetyCard / SafetyList ──────────────────────────────────
  'demo.safety.heading': 'Seguridad',
  'demo.safety.description': 'Líneas que no cruzaremos; velos que bajamos. Compartidas por toda la mesa, nunca atribuidas.',
  'demo.safety.linesLabel': 'Líneas (prohibido)',
  'demo.safety.veilsLabel': 'Velos (corte a negro)',
  'demo.safety.removeItem': 'Quitar "{item}"',
  'demo.safety.addLinePlaceholder': 'Añadir una línea…',
  'demo.safety.addVeilPlaceholder': 'Añadir un velo…',
  'demo.safety.addLine': 'Añadir línea',
  'demo.safety.addVeil': 'Añadir velo',

  // ── DemoTableStep: CharacterSheetPanel ──────────────────────────────────────
  'demo.sheet.heading': 'Hoja de Héroe',
  'demo.sheet.hp': 'PG',
  'demo.sheet.ac': 'CA',
  'demo.sheet.classLevel': '{className} · Nv 1',

  // ── CompanionPanel ──────────────────────────────────────────────────────────
  'demo.companion.heading': 'Dispositivo compañero',
  'demo.companion.description':
    'Vincula un teléfono o tableta como segunda pantalla de solo lectura — iniciativa, tiradas recientes y escena se reflejan en el dispositivo. Revoca en cualquier momento.',
  'demo.companion.pairDevice': 'Vincular un dispositivo',
  'demo.companion.qrAriaLabel': 'Código QR de vinculación del dispositivo compañero',
  'demo.companion.copied': 'Copiado',
  'demo.companion.copyLink': 'Copiar enlace',
  'demo.companion.revoke': 'Revocar',

  // ── MacroTray ───────────────────────────────────────────────────────────────
  'demo.macros.heading': 'Macros de Dados',
  'demo.macros.dismissError': 'Descartar error',
  'demo.macros.newMacro': 'Nueva macro',
  'demo.macros.namePlaceholder': 'Nombre (sin puntos)',
  'demo.macros.labelPlaceholder': 'Etiqueta de botón (opcional)',
  'demo.macros.save': 'Guardar macro',
  'demo.macros.noDots': 'Los nombres de macros no pueden contener puntos.',

  // ── PollBoard ───────────────────────────────────────────────────────────────
  'demo.poll.heading': 'Votación',
  'demo.poll.questionPlaceholder': 'Pregunta a la mesa…',
  'demo.poll.optionPlaceholder': 'Opción {n}',
  'demo.poll.removeOption': 'Quitar opción {n}',
  'demo.poll.addOption': 'Añadir opción',
  'demo.poll.openPoll': 'Abrir votación',
  'demo.poll.live': 'En vivo',
  'demo.poll.closed': 'Votación cerrada',
  'demo.poll.vote': 'Votar',
  'demo.poll.closePoll': 'Cerrar votación',
  'demo.poll.startNewPoll': 'Iniciar una nueva votación',

  // ── RecapCard ───────────────────────────────────────────────────────────────
  'demo.recap.heading': 'Resumen de sesión',
  'demo.recap.tagline': 'La historia de tu mesa, cuando se disipa el polvo.',
  'demo.recap.gathering': 'Recopilando la historia…',
  'demo.recap.getRecap': 'Obtener resumen de sesión',
  'demo.recap.notableRolls': 'Tiradas notables',
  'demo.recap.copied': '¡Copiado!',
  'demo.recap.share': 'Compartir',

  // ── ReferenceCard / ReferenceDetail ─────────────────────────────────────────
  'demo.reference.heading': 'Referencia',
  'demo.reference.searchPlaceholder': 'Busca un monstruo, hechizo, regla…',
  'demo.reference.searchAria': 'Busca en la enciclopedia para compartir',
  'demo.reference.typeToSearch': 'Escribe al menos dos letras para buscar en la enciclopedia viviente.',
  'demo.reference.searching': 'Buscando…',
  'demo.reference.open': 'Abrir {title}',
  'demo.reference.share': 'Compartir',
  'demo.reference.dismiss': 'Descartar referencia',
  'demo.reference.backToSearch': 'Volver a la búsqueda',
  'demo.reference.loadingContent': 'Cargando contenido…',
  'demo.reference.notOwned':
    'Aún no posees este libro. La referencia completa se desbloquea cuando lo añadas a tu biblioteca.',
  'demo.reference.contentDown': 'El contenido no está disponible en este momento. Intenta de nuevo en un momento.',
  'demo.reference.noAdditionalContent': 'Sin contenido adicional para esta referencia.',
  'demo.reference.noLinkedContent': 'Sin contenido de libro vinculado para esta referencia.',
  'demo.reference.shareToTable': 'Compartir con la mesa',

  // ── ReplayTimeline ──────────────────────────────────────────────────────────
  'demo.replay.heading': 'Reproducción',
  'demo.replay.tagline': 'Recorre la sesión momento a momento.',
  'demo.replay.loading': 'Cargando…',
  'demo.replay.loadReplay': 'Cargar reproducción',
  'demo.replay.loadMore': 'Cargar más',

  // ── RollFeed / VisibilityToggle ─────────────────────────────────────────────
  'demo.dice.heading': 'Dados',
  'demo.dice.dismissError': 'Descartar error',
  'demo.dice.labelPlaceholder': 'Ataque (opcional)',
  'demo.dice.roll': 'Tirar',
  'demo.dice.rolledForReal': 'Lo tiré de verdad',
  'demo.dice.totalPlaceholder': 'Total (requerido)',
  'demo.dice.physNotationPlaceholder': '1d20+5 (opcional)',
  'demo.dice.physLabelPlaceholder': 'Etiqueta (opcional)',
  'demo.dice.logPhysical': 'Registrar tirada física',
  'demo.dice.onTable': '🎲 sobre-mesa',
  'demo.dice.private': 'Privado',
  'demo.dice.public': 'Público',
  'demo.dice.rolledPrivately': 'tirado en privado',
  'demo.dice.exploded': 'explosivo',

  // ── SceneBoard ──────────────────────────────────────────────────────────────
  'demo.scene.heading': 'Escena y pistas',
  'demo.scene.current': 'Escena: {scene}',
  'demo.scene.cueSuffix': '— pista: {cue}',
  'demo.scene.noScene': 'Sin escena fijada',
  'demo.scene.oneShotCues': 'Pistas de un solo uso',

  // ── TableMap ────────────────────────────────────────────────────────────────
  'demo.map.tokenAt': '{label} en {x},{y}',
  'demo.map.tile': 'Casilla {x},{y}',
  'demo.map.fogged': 'Ocultada',
  'demo.map.battleMap': 'Mapa de combate',
  'demo.map.gm': 'DJ',
  'demo.map.noMap': 'Sin mapa',
  'demo.map.uploadedMap': 'Mapa cargado',
  'demo.map.uploadTitle': 'Carga una imagen de mapa como fondo del lienzo',
  'demo.map.reading': 'Leyendo…',
  'demo.map.upload': 'Cargar',
  'demo.map.size': 'Tamaño',
  'demo.map.shrinkMap': 'Reducir mapa',
  'demo.map.growMap': 'Ampliar mapa',
  'demo.map.widthShort': 'A',
  'demo.map.narrowMap': 'Estrechar mapa',
  'demo.map.widenMap': 'Ensanchar mapa',
  'demo.map.heightShort': 'A',
  'demo.map.shortenMap': 'Acortar mapa',
  'demo.map.heightenMap': 'Alargar mapa',
  'demo.map.fitTitle': 'Reinicia posición + estira para llenar la cuadrícula',
  'demo.map.fit': 'Encajar',
  'demo.map.lock': 'Bloquear',
  'demo.map.adjust': 'Ajustar',
  'demo.map.fogOn': 'Niebla ACTIVADA — pulsa para desactivar',
  'demo.map.fogOff': 'Niebla DESACTIVADA — pulsa para activar',
  'demo.map.fog': 'Niebla',
  'demo.map.exitPaintTitle': 'Salir del modo pintura',
  'demo.map.paintTitle': 'Pinta niebla — pulsa o arrastra celdas para revelar/ocultar',
  'demo.map.exitPaint': 'Salir de pintura',
  'demo.map.paint': 'Pintar',
  'demo.map.hexGridTitle': 'Cuadrícula hexagonal — pulsa para cuadrada',
  'demo.map.squareGridTitle': 'Cuadrícula cuadrada — pulsa para hexagonal',
  'demo.map.hex': 'Hexágono',
  'demo.map.zoomOut': 'Alejar',
  'demo.map.zoomLevel': 'Nivel de zoom',
  'demo.map.zoomIn': 'Acercar',
  'demo.map.resetView': 'Reiniciar vista',
  'demo.map.reset': 'Reiniciar',

  // ── DockPanel ───────────────────────────────────────────────────────────────
  'demo.dock.expand': 'Expandir {title}',
  'demo.dock.collapse': 'Contraer {title}',

  // ── LeaveTableGuard ─────────────────────────────────────────────────────────
  'demo.leave.ariaLabel': '¿Abandonar la mesa?',
  'demo.leave.heading': '¿Abandonar la mesa?',
  'demo.leave.body':
    'Estás en medio de una partida. Esta es una mesa de invitados — si te vas ahora, la sesión termina y tu héroe se pierde.',
  'demo.leave.stay': 'Quedarse en la mesa',
  'demo.leave.leaveAnyway': 'Abandonar de todas formas',
}
